<template>
  <div class="marginBT">
    <div class="marginLR center titlesContainer">
      <h2 class="titles">
        {{ $t("datos.grandesCuentas.operacion.alta.datos.titulo") }}
      </h2>
      <p class="subtitles">
        {{ $t("datos.grandesCuentas.operacion.alta.datos.subtitulo") }}
      </p>
    </div>

    <div class="whitePanel marginBottom">
      <Errors
        v-if="this.errors && this.errors.length > 0"
        :errors="this.errors"
      />

      <div class="grid">
        <div class="col-12">
          <p class="blueText marginB5Px">
            {{ $t("datos.grandesCuentas.operacion.alta.datos.cartera") }}
          </p>
          <ListadoCarterasUsuario
            :filters="carteraUsuarioFilters"
            :tituloHeader="$t('common.titulos.seleccione')"
            @cartera-usuario-click="onCarteraUsuarioClick"
            :showCarteraColumns="true"
            :selectedCarteraUsuarioValue="operacion.carteraUsuario"
          />
          <Success
            v-if="success && success.length > 0"
            :success="this.success"
          />
        </div>
        <div class="col-12">
          <p class="blueText marginB5Px">
            {{ $t("datos.grandesCuentas.operacion.alta.datos.producto") }}
          </p>
          <ListadoProductos
            :idLegalCliente="idLegalClienteCarteraSelected"
            :tituloHeader="$t('common.titulos.seleccione')"
            @producto-click="
              onProductoClick($event);
              checkBonoAplicable($event);
            "
            :selectedProductoValue="operacion.producto"
          />
        </div>
        <div class="col-12">
          <p class="smallBlueText">
            <i class="pi pi-info" />{{ $t("datos.textos.camposObligatorios") }}
          </p>
        </div>
        <div class="col-12">
          <div class="grid marginB5Px">
            <div class="col-12 md:col-6">
              <p class="blueText">
                {{
                  this.$t(
                    "datos.grandesCuentas.operacion.alta.datos.referenciaClienteOperacion.titulo"
                  )
                }}
              </p>
              <InputText
                class="input"
                id="referenciaCliente"
                type="text"
                v-model="operacion.referenciaCliente"
                @change="checkReferenciaCliente"
                :placeholder="
                  $t(
                    'datos.grandesCuentas.operacion.alta.datos.referenciaClienteOperacion.placeholder'
                  )
                "
              />
            </div>
            <div class="col-12 md:col-6">
              <p class="blueText">{{ this.$t("datos.label.preguntaDeuda") }}</p>
              <Dropdown
                v-model="operacion.origenDeuda"
                class="input"
                :options="origenesDeuda"
                optionLabel="valor"
                optionValue="clave"
                @change="onOrigenDeudaChange"
                :placeholder="this.$t('datos.placeholders.origen')"
              />
            </div>
            <div class="col-12 md:col-6">
              <p class="blueText">
                {{
                  this.$t(
                    "datos.grandesCuentas.operacion.alta.datos.ficherosMorosidad.titulo"
                  )
                }}
              </p>
              <MultiSelect
                v-model="operacion.ficherosMorosidad"
                class="input"
                :options="ficherosMorosidad"
                optionLabel="valor"
                optionValue="clave"
                :placeholder="
                  this.$t(
                    'datos.grandesCuentas.operacion.alta.datos.ficherosMorosidad.label'
                  )
                "
                @change="onMultiSelectChange"
              />
            </div>
            <div class="col-12 md:col-6">
              <p class="blueText">
                {{
                  this.$t(
                    "datos.grandesCuentas.operacion.alta.datos.procedimientoJudicial.titulo"
                  )
                }}
              </p>
              <Dropdown
                v-model="operacion.procedimientoJudicial"
                class="input"
                :options="procesosJudiciales"
                optionLabel="valor"
                optionValue="clave"
                :placeholder="this.$t('datos.placeholders.procesoJudicial')"
              />
            </div>
            <div class="col-12 separatorLine">
              <Segmento 
                nivel="OPERACION" 
                ref="carteraUsuario"
                :carteraUsuario="this.operacion.carteraUsuario">
              </Segmento> 
            </div>
          </div>
        </div>
      </div>
      </div>
      <Dialog
      :visible.sync="displayModalFaltaInformacion"
      :modal="true"
      :contentStyle="{ overflow: 'visible' }"
      :closable="false"
    >
      <template #header>
        <span>
          {{ $t("datos.header.faltaInformacion") }}
        </span>
      </template>
      <div class="grid paddingLR">
        <div class="col-12">
          {{ $t("datos.textos.faltaInformacion") }}
        </div>
      </div>
      <template #footer>
        <div class="center">
          <Button
            :label="$t('common.buttons.accept')"
            icon="pi pi-check"
            @click="redirigirAlProfile()"
            autofocus
          />
        </div>
      </template>
    </Dialog>
    <Dialog
      :visible.sync="displayModalReferenciaDuplicada"
      :modal="true"
      :contentStyle="{ overflow: 'visible' }"
      :closable="false"
    >
      <template #header>
        <span>
          {{ $t("operacion.detalleOperacion.dialogReferenciaClienteDuplicada") }}
        </span>
      </template>
      <div class="grid paddingLR">
        <div class="col-12">
          {{ $t("operacion.detalleOperacion.mensajeDialogReferenciaOperacionDuplicada") }}
        </div>
      </div>
      <template #footer>
        <div class="center">
          <Button
            :label="$t('common.buttons.no')"
            icon="pi pi-times"
            @click="clearReferenciaCliente()"
            class="button darkBlueBG"
          />
          <Button
            :label="$t('common.buttons.yes')"
            icon="pi pi-check"
            @click="redirigirAExpedientes()"
            autofocus
          />
        </div>
      </template>
     
    </Dialog>
  </div>
</template>

<script>
import { TIPOS_SERVICIOS_PRODUCTO } from "@/resources/constants.js";
import { GET_USUARIO_BY_UUID } from "@/graphQLQueries/UsuarioQueries";
import { QUERY_GET_OPERACION_IDLEGAL_REF } from "@/graphQLQueries/OperacionQueries"
import { GET_DEBT_ORIGIN_LIST } from "@/graphQLQueries/OtrosQueries";

import validations from "@/utils/validations.js";
import MessagesMixin from "@/utils/messages";
import Errors from "@/components/utilidades/Errors.vue";
import ListadoCarterasUsuario from "@/components/portal-gran-cliente/Carteras/ListadoCarterasUsuario";
import ListadoProductos from "@/components/portal-gran-cliente/productos/ListadoProductos.vue";
import RoutesMixin from "@/utils/routes";
import Success from "@/components/utilidades/Success.vue";
import Segmento from "./Segmentos/Segmento"


const PROCEDIMIENTO_JUDICIAL_DESFAVORABLE = "siAccionLegalDesfavorable";

export default {
  name: "DatosOperacion",
  mixins: [MessagesMixin, RoutesMixin],
  props: {
    datosOperacion: {
      type: Object,
      required: true,
    },
  },
  components: {
    Errors,
    Success,
    ListadoCarterasUsuario,
    ListadoProductos,
    Segmento
  },
  data() {
    return {
      errors: [],
      success: [],
      displayModalFaltaInformacion: false,
      displayModalReferenciaDuplicada: false,
      operacion: this.datosOperacion,
      clienteIdLegal: null,
      origenesDeuda: [],
      ficherosMorosidadKeys: {
        none: "",
        experian: "EXPERIAN",
        asnef: "ASNEF",
        rij: "RIJ",
      },
      productoAExito: TIPOS_SERVICIOS_PRODUCTO.A_EXITO,
      procesosJudiciales: [
        {
          clave: "noAccionLegal",
          valor: this.$t("datos.label.emprenderAccionLegal"),
        },
        {
          clave: "siAccionLegalFavorable",
          valor: this.$t("datos.label.procesoJudicialFavorable"),
        },
        {
          clave: PROCEDIMIENTO_JUDICIAL_DESFAVORABLE,
          valor: this.$t("datos.label.procesoJudicialDesfavorable"),
        },
      ],
    };
  },
  created() {
    this.setIdLegalCliente();
    this.retrieveDebtOrigins();
  },
  mounted() {
    this.retrieveUserIDLegal();
  },
  methods: {
    onMultiSelectChange(evt) {
      const items = evt.value;
      const itemsFiltered = items.filter(
        (i) => i !== this.ficherosMorosidadKeys.none
      );
      if (items[items.length - 1] !== this.ficherosMorosidadKeys.none) {
        if (
          itemsFiltered.length > 0 &&
          items.includes(this.ficherosMorosidadKeys.none)
        )
          this.operacion.ficherosMorosidad.splice(
            0,
            this.operacion.ficherosMorosidad.length,
            ...itemsFiltered
          );
      } else {
        const itemFiltered = items.filter(
          (i) => i === this.ficherosMorosidadKeys.none
        );
        this.operacion.ficherosMorosidad.splice(
          0,
          this.operacion.ficherosMorosidad.length,
          ...itemFiltered
        );
      }
    },
    setIdLegalCliente() {
      this.clienteIdLegal = this.$store.state.clienteIdLegal;
      this.$store.watch(
        () => {
          return this.$store.state.clienteIdLegal;
        },
        (newValue) => {
          this.clienteIdLegal = newValue;
        }
      );
    },
    onCarteraUsuarioClick(carteraUsuario) {
      if (!carteraUsuario) {
        this.operacion.carteraUsuario = null;
        this.operacion.producto = null;
        return;
      }
      this.operacion.carteraUsuario = carteraUsuario;
    },
    onProductoClick(producto) {
      if (!producto) {
        this.operacion.producto = null;
        return;
      }
      this.operacion.producto = producto;
    },
    checkBonoAplicable(producto) {
      this.success = [];

      if (producto) {
        const bono =
          producto.promociones && producto.promociones.length > 0
            ? producto.promociones.find(
                (promo) =>
                  promo.usosPendientes &&
                  promo.literalTipoPromocion.clave === "BONO"
              )
            : null;

        if (bono) {
          const usosRestantes = bono.numeroUsos - bono.contadorUsos;

          if (usosRestantes > 0) {
            this.success.push(
              this.$i18n.t("consultaFichero.textos.bonoAplicado1") +
                usosRestantes +
                this.$i18n.t("consultaFichero.textos.bonoAplicado2")
            );
            window.scrollTo(0, 0);
          } else if(usosRestantes <= 0 && !producto.contrato.excesos) {
            this.errors.push(
              this.$i18n.t("consultaFichero.textos.bonoAplicadoSinUsosNiExcesos")
            );
            window.scrollTo(0, 0);
          }
        }
      }
    },
    validateOperacion() {
      this.errors = [];
      this.validateCartera();
      this.validateProducto();
      this.validateOrigenDeuda();
      this.validateFicherosMorosidad();
      this.validateReferenciaClienteOperacion();
      this.validateProcesoJudicial();
      this.validateAtributo();
      this.validatePromocion();
    },
    validateCartera() {
      if (!this.operacion.carteraUsuario || !this.operacion.carteraUsuario.id)
        this.errors.push(
          this.$t(
            "datos.grandesCuentas.operacion.alta.datos.errores.carteraObligatoria"
          )
        );
    },
    validateProducto() {
      if (!this.operacion.producto || !this.operacion.producto.id)
        this.errors.push(
          this.$t(
            "datos.grandesCuentas.operacion.alta.datos.errores.productoObligatorio"
          )
        );
      this.validatePromocionesProducto();
    },
    validatePromocionesProducto() {
      if (
        !this.operacion.producto.contrato.excesos &&
        this.operacion.producto &&
        this.productoAExito !=
          this.operacion.producto.literalTipoServicio.clave &&
        this.operacion.producto.promociones &&
        !this.operacion.producto.promociones.some((p) => p.usosPendientes)
      )
        this.errors.push(
          this.$t(
            "datos.grandesCuentas.operacion.alta.datos.errores.productoSinPromocionesValidas"
          )
        );
    },
    validatePromocion() {
      let promocion = this.operacion.producto.promociones[0]
      if(this.operacion.producto.promociones.length > 0 && promocion.contadorUsos >= promocion.numeroUsos && this.operacion.producto.combinado == null) {
        this.errors.push(this.$t("datos.grandesCuentas.operacion.alta.datos.errores.promocionSinUsosPendientes"));
      }
    },
    validateOrigenDeuda() {
      if (!this.operacion.origenDeuda)
        this.errors.push(
          this.$t(
            "datos.grandesCuentas.operacion.alta.datos.errores.origenDeudaObligatorio"
          )
        );
    },
    validateFicherosMorosidad() {
      if (this.operacion.ficherosMorosidad.length === 0)
        this.errors.push(
          this.$t(
            "datos.grandesCuentas.operacion.alta.datos.errores.ficheroMorosidadObligatorio"
          )
        );
    },
    validateReferenciaClienteOperacion() {
      if (!this.operacion.referenciaCliente)
        this.errors.push(
          this.$t(
            "datos.grandesCuentas.operacion.alta.datos.errores.referenciaClienteOperacionObligatoria"
          )
        );
    },
    validateProcesoJudicial() {
      if (!this.operacion.procedimientoJudicial) {
        this.errors.push(
          this.$t(
            "datos.grandesCuentas.operacion.alta.datos.errores.procesoJudicialObligatorio"
          )
        );
      } else if (
        this.operacion.procedimientoJudicial ===
        PROCEDIMIENTO_JUDICIAL_DESFAVORABLE
      ) {
        this.errors.push(
          this.$t(
            "datos.grandesCuentas.operacion.alta.datos.errores.procesoJudicialDesfavorable"
          )
        );
      }
    },
    validateAtributo(){
      let atributosErrors = this.$refs.carteraUsuario.getErrors() 
      for (let i = 0; i < atributosErrors.length; i++) {
        this.errors.push(atributosErrors[i])
      }
    },
    hasOperacionErrors() {
      return this.errors.length > 0;
    },
    retrieveUserIDLegal() {
      this.$apollo
        .query({
          query: GET_USUARIO_BY_UUID,
          variables: {
            uuidUsuario: this.$store.state.profile.uuid,
            idioma: this.$i18n.locale,
          },
          fetchPolicy: "no-cache",
        })
        .then(({data}) => {
          if (
            this.$store.state.codigoPromotor != this.promotorEinforma &&
            ((data.getUsuarioUuid.genero !== "company" &&
              !data.getUsuarioUuid.apellidos) ||
              !data.getUsuarioUuid.nombre ||
              (!this.$store.state.esGranCliente &&
                (!data.getUsuarioUuid.idLegal ||
                  !validations.validateNif(data.getUsuarioUuid.idLegal))) ||
              !data.getUsuarioUuid.cliente.contactosActivos ||
              !data.getUsuarioUuid.cliente.contactosActivos.direccion ||
              !data.getUsuarioUuid.cliente.contactosActivos.direccion.valor ||
              !data.getUsuarioUuid.cliente.contactosActivos.direccion.valor
                .tipoDireccion ||
              !data.getUsuarioUuid.cliente.contactosActivos.direccion.valor
                .direccion ||
              !data.getUsuarioUuid.cliente.contactosActivos.direccion.valor
                .localidad ||
              !data.getUsuarioUuid.cliente.contactosActivos.direccion.valor
                .provincia ||
              !data.getUsuarioUuid.cliente.contactosActivos.direccion.valor
                .pais ||
              !data.getUsuarioUuid.cliente.contactosActivos.direccion.valor
                .codigoPostal)
          ) {
            this.displayModalFaltaInformacion = true;
          }
        })
        .catch(() => {
          this.setMessages(
            "error",
            this.$t("datos.messages.error.errorGenerico"),
            3000
          );
        });
    },
    retrieveDebtOrigins() {
      this.$apollo
        .query({
          query: GET_DEBT_ORIGIN_LIST,
          variables: {
            idioma: this.$i18n.locale,
          },
        })
        .then((data) => {
          this.origenesDeuda = data.data.listadoOrigenesDeuda;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    checkReferenciaCliente() {
      if (this.operacion.referenciaCliente && this.operacion.carteraUsuario.cliente.idLegal){
        this.$apollo
        .query({
          query: QUERY_GET_OPERACION_IDLEGAL_REF,
          variables: {
            "idLegalCliente": this.operacion.carteraUsuario.cliente.idLegal,
            "referenciaCliente": this.operacion.referenciaCliente
          },
          fetchPolicy: "no-cache"
        })
        .then((data) => {
          if (data.data.operacion && data.data.operacion.id)
            this.displayModalReferenciaDuplicada=true;
        })
        .catch((error) => {
          console.error(error);
        });
      }      
    },
    onOrigenDeudaChange(evt) {
      this.datosOperacion.literalOrigenDeuda = this.origenesDeuda.find(
        (od) => od.clave == evt.value
      ).valor;
    },
    redirigirAlProfile() {
      this.goToProfile();
    },
    redirigirAExpedientes(){
      this.goToListaExpedientesGrandesCuentas(this.operacion.referenciaCliente);
      this.displayModalReferenciaDuplicada=false;
    },
    clearReferenciaCliente(){
      this.operacion.referenciaCliente="";
      this.displayModalReferenciaDuplicada=false;
    }
  },
  computed: {
    ficherosMorosidad() {
      return [
        {
          valor: this.$t(
            "datos.grandesCuentas.operacion.alta.datos.ficherosMorosidad.opciones.noFichero"
          ),
          clave: this.ficherosMorosidadKeys.none,
        },
        {
          valor: this.$t(
            "datos.grandesCuentas.operacion.alta.datos.ficherosMorosidad.opciones.asnef"
          ),
          clave: this.ficherosMorosidadKeys.asnef,
        },
        {
          valor: this.$t(
            "datos.grandesCuentas.operacion.alta.datos.ficherosMorosidad.opciones.experian"
          ),
          clave: this.ficherosMorosidadKeys.experian,
        },
        {
          valor: this.$t(
            "datos.grandesCuentas.operacion.alta.datos.ficherosMorosidad.opciones.rij"
          ),
          clave: this.ficherosMorosidadKeys.rij,
        }
      ];
    },
    carteraUsuarioFilters() {
      return [
        `usuario.cliente.idLegal~eq=${this.clienteIdLegal}`,
        `cartera.operativa~booleanEQ=true`,
      ];
    },
    idLegalClienteCarteraSelected() {
      return this.operacion.carteraUsuario
        ? this.operacion.carteraUsuario.cliente.idLegal
        : null;
    },
  },
};
</script>

<style lang="scss" scoped>
.titlesContainer {
  padding-bottom: 1.25em !important;
}
.separatorLine {
  margin-top: 1.8rem;
  border-top: solid #e9ecef;
  border-width: 1px 0 0 0;
  border-radius: 0;
  padding-top: 1rem;
}
</style>
